import { useEffect, useState } from 'react';
export const useFocus = (ref) => {
    const [focused, setFocused] = useState(false);
    useEffect(() => {
        const onFocus = () => setFocused(true);
        ref.current?.addEventListener('focusin', onFocus);
        const onBlur = (e) => setFocused(ref.current?.contains(e.relatedTarget));
        ref.current?.addEventListener('focusout', onBlur);
        return () => {
            ref.current?.removeEventListener('focusin', onFocus);
            ref.current?.removeEventListener('focusout', onBlur);
        };
    }, []);
    return focused;
};
